import { Unit } from "./Unit";
import { UnitGroup } from "./UnitGroup";

export class DistanceUnits extends UnitGroup {
    private static _singleton: DistanceUnits;

    public static readonly KILOMETER = new Unit("KM", "Kilometers");
    public static readonly MILE = new Unit("MI", "Miles");
    
    constructor() {
        const units = [ DistanceUnits.KILOMETER, DistanceUnits.MILE ];
        super(units, "distance_company_um", "distance_functional_um");
    }

    public static get singleton(): DistanceUnits {
        if (this._singleton == null) {
            this._singleton = new DistanceUnits();
        }
        return this._singleton;
    }
}
